import React from 'react';
import { Button, Input, Typography, Tooltip, Badge, message } from 'antd';
import { IoAdd, IoPricetagsOutline } from "react-icons/io5";
import { QuestionCircleOutlined, DeleteOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
const { Text } = Typography;

// Función generadora extraída para validar BD y Variantes locales
const generarEAN13Unico = (productosDB, variantesActuales = []) => {
    let esUnico = false;
    let codigoFinal = '';

    while (!esUnico) {
        // Generar la base
        let code = '20'; 
        for(let i=0; i<10; i++) code += Math.floor(Math.random() * 10).toString();
        
        // 2. Calcular dígito de control
        let sum = 0;
        for (let i = 0; i < 12; i++) {
            sum += parseInt(code.charAt(i)) * (i % 2 === 0 ? 1 : 3);
        }
        const checkDigit = (10 - (sum % 10)) % 10;
        const candidato = code + checkDigit.toString();

        // Validar contra la BD global (productos y sus variantes)
        const existeBD = productosDB.some(p => {
            if (String(p.codigo_barras) === candidato || String(p.codigo_interno) === candidato) return true;
            if (p.variantes && Array.isArray(p.variantes)) {
                return p.variantes.some(v => String(v.codigo_barras) === candidato || String(v.codigo_interno) === candidato);
            }
            return false;
        });

        // Validar contra las variantes que estamos creando en la tabla local
        const existeVariantes = variantesActuales.some(v => 
            String(v.codigo_barras) === candidato || String(v.codigo_interno) === candidato
        );

        if (!existeBD && !existeVariantes) {
            codigoFinal = candidato;
            esUnico = true;
        }
    }
    return codigoFinal;
};

const SeccionVariantesModal = ({ 
    producto, productosDB, setProducto, productoGuardado, calcularMargenDesdePrecio, calcularPrecioAlPublico,
    calcularPrecioDesdeMargen, abrirModalPrecios
}) => {

    const contarListasActivasVariantes = (preciosObj) => {
        if (!preciosObj) return 0;
        return Object.entries(preciosObj).filter(([_, val]) => Number(val) > 0).length;
    };

    const verificarCodigoUnico = (codigo, indexVariante) => {
        if (!codigo || String(codigo).trim() === "") return null;
        const codStr = String(codigo).trim();

        const duplicadoEnTabla = producto.variantes.some((v, i) => {
            if (i === indexVariante) return false;
            return String(v.codigo_barras).trim() === codStr || String(v.codigo_interno).trim() === codStr;
        });

        if (duplicadoEnTabla) return "Este código ya está asignado a otra presentación en esta tabla";

        for (const p of productosDB) {
            if (p.id === producto.id) continue;

            if (String(p.codigo_barras).trim() === codStr || String(p.codigo_interno).trim() === codStr)
                return `Usado en producto: ${p.nombre}`;

            if (p.variantes && Array.isArray(p.variantes)) {
                const varExist = p.variantes.find(v =>
                    String(v.codigo_barras).trim() === codStr || String(v.codigo_interno).trim() === codStr
                );
                if (varExist) return `Usado en: ${p.nombre} (${varExist.atributos?.nombre || 'Variante'})`;
            }
        }
        return null;
    };

    return (
        <div style={{ marginTop: '15px', background: '#f8fafc', padding: '15px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>

            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px', alignItems: 'center' }}>
                <Text strong style={{ fontSize: '14px', color: '#1e293b' }}>Gestión de Variantes y Precios</Text>
                <Button type="primary" size="large" title='Agregar variante' icon={<IoAdd size={18} />} style={{ background: '#10b981', borderColor: '#10b981', fontWeight: '600', padding: '5px 12px' }}
                    onClick={() => {
                        const nuevaVariante = {
                            id: null,
                            codigo_barras: "",
                            codigo_interno: "",
                            atributos: { nombre: "" },
                            stock: 0,
                            precio_compra: "",
                            precio_base: "",
                            precio_catalogo: "",
                            descuento: 0,
                            status: 'active'
                        };
                        setProducto({ ...producto, variantes: [...producto.variantes, nuevaVariante] });
                    }}>Agregar Variante</Button>
            </div>

            {(producto.variantes?.length || 0) === 0 ? (
                <div style={{ textAlign: 'center', padding: '20px', color: '#94a3b8', border: '2px dashed #cbd5e1', borderRadius: '8px', background: '#fff' }}>Haz clic en "Agregar Variante" para comenzar.</div>
            ) : (
                <div style={{ overflowX: 'auto', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                    <table style={{ width: '100%', minWidth: '1500px', borderCollapse: 'collapse', background: '#fff' }}>
                        <thead>
                            <tr style={{ background: '#f1f5f9', fontSize: '11px', textTransform: 'uppercase', color: '#475569' }}>
                                <th style={{ padding: '10px 8px', textAlign: 'left', width: '270px' }}>Nombre</th>
                                <th style={{ padding: '10px 8px', textAlign: 'left', width: '270px' }}>Cód. Barras</th>
                                <th style={{ padding: '10px 8px', textAlign: 'left', width: '130px' }}>SKU <Tooltip title="Asigna un código corto (ej. 001) para buscar y vender rápidamente productos que no tienen código de barras de fábrica." color="#1890ff"><QuestionCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} /></Tooltip></th>
                                <th style={{ padding: '10px 8px', textAlign: 'left', width: '130px' }}>Stock</th>
                                <th style={{ padding: '10px 8px', textAlign: 'left', width: '130px' }}>Costo Compra</th>
                                <th style={{ padding: '10px 8px', textAlign: 'left', width: '130px' }}>Margen % <Tooltip title="Usamos el Margen Bruto Comercial. Esto calcula qué porcentaje del precio final que paga el cliente será tu ganancia libre." color="#1890ff"><QuestionCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} /></Tooltip></th>
                                <th style={{ padding: '10px 8px', textAlign: 'left', width: '130px' }}>Precio de Venta</th>
                                <th style={{ padding: '10px 8px', textAlign: 'left', width: '130px' }}>Precio Catálogo <Tooltip title="El precio del producto en el catálogo web puede ser diferente o igual al que manejas en el punto físico." color="#1890ff"><QuestionCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} /></Tooltip></th>
                                <th style={{ padding: '10px 8px', textAlign: 'left', width: '130px' }}>Listas Precios</th>
                                <th style={{ padding: '10px 8px', textAlign: 'left', width: '130px' }}>Dcto %</th>
                                <th style={{ padding: '10px 8px', textAlign: 'left', width: '130px' }}>Precio Público <Tooltip title="El precio al público es con base en el precio de venta y el descuento aplicado." color="#1890ff"><QuestionCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} /></Tooltip></th>
                                <th style={{ padding: '10px 8px', textAlign: 'center', width: '60px' }}>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {producto.variantes.map((v, index) => {

                                const varianteOriginal = (productoGuardado && v.id)
                                    ? productoGuardado.variantes?.find(vari => vari.id === v.id)
                                    : null;

                                const tieneBarrasOriginal = varianteOriginal ? !!(varianteOriginal.codigo_barras && String(varianteOriginal.codigo_barras).trim() !== "") : false;
                                const tieneSkuOriginal = varianteOriginal ? !!(varianteOriginal.codigo_interno && String(varianteOriginal.codigo_interno).trim() !== "") : false;

                                const margenVar = calcularMargenDesdePrecio(v.precio_compra, v.precio_base);
                                const publicoVar = calcularPrecioAlPublico(v.precio_base, v.descuento);

                                return (
                                    <tr key={index} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                        <td style={{ padding: '6px' }}>
                                            <Input placeholder="Ej: Talla, Color, etc.." value={v.atributos.nombre} style={{ fontSize: '13px' }}
                                                onChange={(e) => { const newVar = [...producto.variantes]; newVar[index].atributos.nombre = e.target.value; setProducto({ ...producto, variantes: newVar }); }} />
                                        </td>
                                        <td style={{ padding: '6px' }}>
                                            <Input
                                                placeholder="Cód. Barras"
                                                disabled={tieneBarrasOriginal && !!v.id}
                                                title={(tieneBarrasOriginal && !!v.id) ? "El código de barras de un producto o variante ya creado no se puede modificar por temas de trazabilidad." : ""}
                                                value={v.codigo_barras}
                                                style={{ fontSize: '13px' }}
                                                status={verificarCodigoUnico(v.codigo_barras, index) ? "error" : ""}
                                                onChange={(e) => { const newVar = [...producto.variantes]; newVar[index].codigo_barras = e.target.value; setProducto({ ...producto, variantes: newVar }); }}
                                                suffix={
                                                    (!tieneBarrasOriginal || !v.id) ? (
                                                        <Tooltip title="Generar código interno (EAN-13)">
                                                            <Button 
                                                                type="text" 
                                                                icon={<IoPricetagsOutline size={16} />} 
                                                                style={{ background: '#22BABB', borderColor: '#22BABB', boxShadow: 'none' }}
                                                                onClick={() => {
                                                                    const nuevoCodigo = generarEAN13Unico(productosDB, producto.variantes);
                                                                    const newVar = [...producto.variantes];
                                                                    newVar[index].codigo_barras = nuevoCodigo;
                                                                    setProducto({ ...producto, variantes: newVar });
                                                                    message.success("Código generado para la variante.");
                                                                }}
                                                            />
                                                        </Tooltip>
                                                    ) : null
                                                }
                                            />
                                        </td>
                                        <td style={{ padding: '6px' }}>
                                            <Input
                                                placeholder="SKU"
                                                value={v.codigo_interno}
                                                style={{ fontSize: '13px' }}
                                                disabled={tieneSkuOriginal && !!v.id}
                                                title={(tieneSkuOriginal && !!v.id) ? "El SKU de una variante ya creada no se puede modificar por temas de trazabilidad." : ""}
                                                status={verificarCodigoUnico(v.codigo_interno, index) ? "error" : ""}
                                                onChange={(e) => { const newVar = [...producto.variantes]; newVar[index].codigo_interno = e.target.value; setProducto({ ...producto, variantes: newVar }); }}
                                            />
                                        </td>
                                        <td style={{ padding: '6px' }}>
                                            <Input
                                                type="number"
                                                value={v.stock}
                                                disabled={!!v.id}
                                                title={!!v.id ? "Para cambiar el stock usa el módulo de inventario." : ""}
                                                style={{ fontSize: '14px', fontWeight: 'bold', textAlign: 'center' }}
                                                onChange={(e) => { const newVar = [...producto.variantes]; newVar[index].stock = e.target.value; setProducto({ ...producto, variantes: newVar }); }}
                                                onFocus={(e) => e.target.select()}
                                            />
                                        </td>

                                        <td style={{ padding: '6px' }}>
                                            <Input prefix="$" disabled={!!v.id} title={!!v.id ? "Para cambiar el costo de compra usa el módulo de inventario." : ""} value={v.precio_compra ? new Intl.NumberFormat('es-CO').format(v.precio_compra) : ""} style={{ fontSize: '13px' }}
                                                onChange={(e) => {
                                                    const val = e.target.value.replace(/\./g, '').replace(/[^0-9]/g, '');
                                                    const newVar = [...producto.variantes];
                                                    newVar[index].precio_compra = val;
                                                    setProducto({ ...producto, variantes: newVar });
                                                }}
                                            />
                                        </td>

                                        {/* 2. MARGEN % */}
                                        <td style={{ padding: '6px' }}>
                                            <Input type="number" value={margenVar} style={{ fontSize: '13px', textAlign: 'center' }}
                                                onChange={(e) => {
                                                    const precioCalc = calcularPrecioDesdeMargen(v.precio_compra, e.target.value);
                                                    if (precioCalc !== "") {
                                                        const newVar = [...producto.variantes];
                                                        newVar[index].precio_base = precioCalc;
                                                        newVar[index].precio_catalogo = precioCalc; 
                                                        setProducto({ ...producto, variantes: newVar });
                                                    }
                                                }}
                                            />
                                        </td>

                                        {/* 3. PRECIO DE VENTA */}
                                        <td style={{ padding: '6px' }}>
                                            <Input
                                                prefix="$"
                                                value={v.precio_base ? new Intl.NumberFormat('es-CO').format(v.precio_base) : ""}
                                                style={{ fontSize: '13px', fontWeight: 'bold' }}
                                                onChange={(e) => {
                                                    const val = e.target.value.replace(/\./g, '').replace(/[^0-9]/g, '');
                                                    const newVar = [...producto.variantes];
                                                    newVar[index].precio_base = val;
                                                    newVar[index].precio_catalogo = val;
                                                    setProducto({ ...producto, variantes: newVar });
                                                }}
                                            />
                                        </td>

                                        {/* 4. PRECIO CATÁLOGO */}
                                        <td style={{ padding: '6px' }}>
                                            <Input prefix="$" value={v.precio_catalogo ? new Intl.NumberFormat('es-CO').format(v.precio_catalogo) : ""} style={{ fontSize: '13px' }}
                                                onChange={(e) => {
                                                    const val = e.target.value.replace(/\./g, '').replace(/[^0-9]/g, '');
                                                    const newVar = [...producto.variantes];
                                                    newVar[index].precio_catalogo = val;
                                                    setProducto({ ...producto, variantes: newVar });
                                                }}
                                            />
                                        </td>
                                        <td style={{ padding: '6px', textAlign: 'center' }}>
                                            <Badge count={contarListasActivasVariantes(v.precios_adicionales)} size="small" color="#22BABB" offset={[-5, 5]}>
                                                <Button
                                                    type="primary"
                                                    size="small"
                                                    style={{ background: '#22BABB', borderColor: '#22BABB', fontSize: '12px', fontWeight: 'bold', padding: '0 10px', height: '30px' }}
                                                    icon={<IoPricetagsOutline size={14} />}
                                                    onClick={() => abrirModalPrecios(index)}
                                                    title="Asignar precios a listas adicionales"
                                                >
                                                    Precios
                                                </Button>
                                            </Badge>
                                        </td>
                                        <td style={{ padding: '6px' }}>
                                            <Input
                                                type="number"
                                                value={v.descuento}
                                                style={{ fontSize: '13px', textAlign: 'center', borderColor: v.descuento > 0 ? '#52c41a' : '' }}
                                                onChange={(e) => { const val = Math.min(100, Math.max(0, Number(e.target.value))); const newVar = [...producto.variantes]; newVar[index].descuento = val; setProducto({ ...producto, variantes: newVar }); }}
                                                onFocus={(e) => e.target.select()}
                                            />
                                        </td>
                                        <td style={{ padding: '6px' }}>
                                            {v.descuento > 0 ? (
                                                <div style={{ background: '#f6ffed', padding: '4px 8px', borderRadius: '4px', border: '1px solid #b7eb8f' }}>
                                                    <Text strong style={{ fontSize: '17px', color: '#389e0d' }}>${publicoVar.toLocaleString('es-CO')}</Text>
                                                </div>
                                            ) : (
                                                <Text type="secondary" style={{ fontSize: '13px' }}>-</Text>
                                            )}
                                        </td>
                                        <td style={{ padding: '6px', textAlign: 'center' }}>
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>

                                                <Button
                                                    type="text"
                                                    icon={v.status === 'active' ? <EyeOutlined style={{ color: '#16a34a' }} /> : <EyeInvisibleOutlined style={{ color: '#ef4444' }} />}
                                                    onClick={() => {
                                                        const newVar = [...producto.variantes];
                                                        newVar[index].status = v.status === 'active' ? 'inactive' : 'active';
                                                        setProducto({ ...producto, variantes: newVar });
                                                    }}
                                                    title={v.status === 'active' ? "Desactivar variante" : "Activar variante"}
                                                />

                                                <Button
                                                    danger
                                                    type="text"
                                                    title='Eliminar variante'
                                                    icon={<DeleteOutlined />}
                                                    onClick={() => {
                                                        const newVar = producto.variantes.filter((_, i) => i !== index);
                                                        setProducto({ ...producto, variantes: newVar });
                                                    }}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    )
}

export default SeccionVariantesModal;